// extracted by mini-css-extract-plugin
module.exports = {"container":"MyAccountLink_container__YR037","chevron":"MyAccountLink_chevron__6cF_e","children":"MyAccountLink_children__3U0Tq","badge":"MyAccountLink_badge__SrpH4"};